<template>
  <TextBlob headingSize="s">
    <template #heading> Settings </template>
    <template #text>
      <div class="w-full flex flex-col items-center overflow-hidden">
        <SettingsUserDetails :user="userStore.user" />
        <SettingsPayment />
        <SettingsEmbed />
        <!-- <SettingsOptimization /> -->
        <SettingsBooleans />
        <SettingsText />
      </div>
    </template>
  </TextBlob>
  <div
    v-if="userStore.showSaveButton"
    class="floating-container w-full min-h-[100px]"
  >
    <div class="w-full flex justify-end">
      <div class="w-full sm:w-1/3 flex justify-center">
        <el-text type="danger">(unsaved changes)</el-text>
      </div>
    </div>
    <el-button
      class="floating-save-button mt-4 w-full sm:w-1/3"
      type="success"
      size="large"
      @click="userStore.saveSettings()"
      v-if="userStore.showSaveButton"
    >
      Save Settings
    </el-button>
  </div>
</template>

<script setup>
import api from "@/composables/api";
import TextBlob from "@/components/TextBlob.vue";
import SettingsUserDetails from "./components/ExplorerSettings/SettingsUserDetails.vue";
import SettingsPayment from "./components/ExplorerSettings/SettingsPayment.vue";
import SettingsBooleans from "./components/ExplorerSettings/SettingsBooleans.vue";
import SettingsText from "./components/ExplorerSettings/SettingsText.vue";
import SettingsEmbed from "./components/ExplorerSettings/SettingsEmbed.vue";
import SettingsOptimization from "./components/ExplorerSettings/SettingsOptimization.vue";
import { useUser } from "@/stores";
const userStore = useUser();
userStore.getSettings();
</script>
<style scoped>
.floating-save-button {
  position: fixed;
  bottom: 20px;
  right: 10px;
  z-index: 1000; /* High z-index to ensure it's above other elements */
  animation: bounce 2s infinite;
}

.floating-container {
  position: fixed;
  bottom: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.5); /* semi-opaque black background */
  z-index: 1000;
}
</style>
